import { createRoot } from 'react-dom/client';
import { useState } from 'react';
import { BmiCalculator, BmiResult } from '@/features/bmi/ui';

export const setupBmiApp = (containerQuery: string) => {
    const elm = document.querySelector(containerQuery);
    if (elm == null) {
        throw new Error(
            `Could not find React root element with query ${containerQuery}`,
        );
    }

    const root = createRoot(elm);
    root.render(<BmiApp />);
};

export function BmiApp() {
    const [pageIndex, setPageIndex] = useState(0);
    const [bmi, setBmi] = useState<number>();
    const [height, setHeight] = useState<number>();
    const [weight, setWeight] = useState<number>();

    return (
        <div className="mb-4 text-left">
            <img
                alt=""
                className="mx-auto mb-6 flex"
                src="./images/icons_shape/sundvaegt_circle.png"
                width={150}
                height={150}
            />
            {pageIndex === 0 && (
                <BmiCalculator
                    setPageIndex={setPageIndex}
                    setBmi={setBmi}
                    height={height}
                    setHeight={setHeight}
                    weight={weight}
                    setWeight={setWeight}
                />
            )}
            {pageIndex === 1 && (
                <BmiResult
                    setPageIndex={setPageIndex}
                    bmi={bmi}
                    height={height}
                    weight={weight}
                />
            )}
        </div>
    );
}
